








































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  AccountListItem
} from "@/admin/types";

import { Validator } from "vee-validate";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useBankAccountBlacklistStore } from "@/admin/store/bankAccountBlacklist";

@Component({
  methods: { isNullEmptyOrUndefined },
  components: {
    ErrorSummary
  }
})
export default class AdminUtilityManageBankAccountBlacklist extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  bankAccountBlacklistStore = useBankAccountBlacklistStore();

  pageNumber = 1;
  filter = 0;
  perPage = 10;
  isDeleteModalVisible = false;
  isAddModalVisible = false;
  isAccountNumberVisible = false;
  itemToDelete: AccountListItem = null;
  itemToAdd: AccountListItem = null;

  initializeModel () {
    this.itemToAdd = {
      bankName: "",
      routingNumber: "",
      accountNumber: "",
      bankAccountBlacklistId: 0
    };
  }
  created (): void {
    this.initializeModel();
    this.reload();
  }

  setFilter (filter: number) {
    this.pageNumber = 1;
    this.filter = filter;
  }

  get isLoaded (): boolean {
    return this.bankAccountBlacklistStore.blackListLoaded;
  }

  reload (): void {
    this.pageNumber = 1;
    this.filter = 0;
    this.bankAccountBlacklistStore.loadBlackList();
  }
  deleteItem (itemToDelete: AccountListItem) {
    this.isDeleteModalVisible = true;
    this.itemToDelete = itemToDelete;
  }
  cancelDelete () {
    this.isDeleteModalVisible = false;
    this.itemToDelete = null;
  }
  continueDelete () {
    if (this.itemToDelete) {
      this.bankAccountBlacklistStore.deleteBlackList(this.itemToDelete.bankAccountBlacklistId);
    }
    this.isDeleteModalVisible = false;
    this.itemToDelete = null;
  }
  addRestrictedRouting () {
    this.initializeModel();
    this.isAccountNumberVisible = false;
    this.isAddModalVisible = true;
  }
  addRestrictedAccount () {
    this.initializeModel();
    this.isAccountNumberVisible = true;
    this.isAddModalVisible = true;
  }
  addRestrictedBankAccount (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.doAddItem();
      });
  }
  doAddItem () {
    this.bankAccountBlacklistStore.createBlackList(this.itemToAdd)
      .then(() => {
        this.reload();
      }).finally ( () => {
        this.isAddModalVisible = false;
        this.initializeModel();
      });
  }
  cancelAdd () {
    this.isAddModalVisible = false;
  }
  onSortChanged () {
    this.pageNumber = 1;
  }
  get filteredItems () {
    if (this.bankAccountBlacklistStore.blackLists) {
      if (this.filter === 1) {
        return this.bankAccountBlacklistStore.blackLists.filter(x => isNullEmptyOrUndefined(x.accountNumber));
      }
      else if (this.filter === 2) {
        return this.bankAccountBlacklistStore.blackLists.filter(x => !isNullEmptyOrUndefined(x.accountNumber));
      }
      return this.bankAccountBlacklistStore.blackLists;
    }
    return [];
  }
  showFields = [
    {
      key: "routingNumber",
      label: "Routing Number",
      thClass: "",
      tdClass: "text-left",
      sortable: true
    },
    {
      key: "accountNumber",
      label: "Bank Account Number",
      thClass: "",
      tdClass: "text-left",
      sortable: true,
    },
    {
      key: "bankName",
      label: "Comment or Institution Name",
      thClass: "",
      tdClass: "text-left",
      sortable: true,
    },
    {
      key: "actions",
      label: "",
      thClass: "",
      tdClass: "text-right",
      sortable: false,
    }
  ];
}
